export default "__VITE_ASSET__yDUwuzk$__"